import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import rootReducer from './reducers';

const store = createStore(
  rootReducer,
  applyMiddleware(
    // This auto switches our promise actions to _FAILED, FULFILLED etc
    promise,
    thunk,
  ),
);

export default store;
